import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicy = lazy(() => import('../pages/legal/PrivacyPolicy'));
const CookiesPolicy = lazy(() => import('../pages/legal/CookiesPolicy'));
const LegalNotice = lazy(() => import('../pages/legal/LegalNotice'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/politica-de-privacidad',
    element: <PrivacyPolicy />
  },
  {
    path: '/politica-de-cookies',
    element: <CookiesPolicy />
  },
  {
    path: '/aviso-legal',
    element: <LegalNotice />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;